(function () {
    'use strict';

    function AdminDocumentsCtrl(restangular, toastr, $scope, $uibModal, appData, $window, authService) {
        var vm = this;

        vm.searchOptions = {
            size: 10,
            page: 1
        };

        vm.removeDocument = removeDocument;
        vm.addDocument = addDocument;
        vm.editDocument = editDocument;

        $scope.$watch(function () { return vm.searchOptions; }, fetch, true);
        restangular.all('categories').one('secondary').getList().then(function (data) {
            vm.secondaryCategories = data;
        });

        restangular.all('categories').one('primary').getList().then(function (data) {
            vm.primaryCategories = data;
        });


        /////////////////////////////////////
        function fetch() {
            restangular
                .one('documents')
                .get(vm.searchOptions)
                .then(function (data) {
                    _.each(data.rows, function (document) {
                        document.downloadLink = document.downloadLink + '?token=' + authService.authentication.token;
                    });
                    vm.documents = data;
                });
        }

        function removeDocument(document) {
            $uibModal.open({ templateUrl: 'admin/documents/confirmation.html' }).result.then(function () {
                restangular.one('documents', document.id).customDELETE().then(function () {
                    toastr.info('Document has been removed.', 'Document Removed');
                    fetch();
                }, function () {
                    toastr.error('Unable to remove document.', 'Error');
                });
            });
        }

        function addDocument() {
            $uibModal.open({
                templateUrl: 'admin/documents/add.html',
                controller: ['$scope', 'Upload', 'cfpLoadingBar', 'primaryCategories', 'secondaryCategories',
                    function ($scope, upload, cfpLoadingBar, primaryCategories, secondaryCategories) {

                    $scope.roles = _.filter(appData.applicationRoles, function(item) {
                        return item !== 'Administrator';
                        });

                    $scope.primaryCategories = primaryCategories;
                    $scope.secondaryCategories = secondaryCategories;

                    $scope.selectedRoles = [];

                    $scope.document = {
                        searchTerms: '',
                        description: '',
                        roles: ''
                    };

                    $scope.onPrimaryCategoryChange = function () {
                        $scope.filteredCategories = _.filter(secondaryCategories, function (o) { return o.primaryCategory == $scope.document.primaryCategory; });
                    }

                    $scope.roleSelected = function () {
                        return $scope.document.roles.length > 0;
                    }

                    $scope.roleChanged = function() {
                        $scope.document.roles = $scope.selectedRoles.join(',');
                    }

                    $scope.fileSelect = function(file) {
                        $scope.selectedFile = file;
                    }

                    $scope.upload = function (form) {
                        if (form.$valid) {
                            $scope.cfpLoadingBar = cfpLoadingBar;
                            $scope.uploading = true;
                            var data = _.extend({ file: $scope.selectedFile }, $scope.document);
                            upload.upload({
                                url: appData.applicationRoot + 'api/documents',
                                data: data,
                                transformRequest: angular.identity,
                                headers: { 'Content-Type': undefined }
                            }).then(function () {
                                toastr.info('Document uploaded successfully.', 'Notification');
                                $scope.uploading = false;
                                fetch();
                                $scope.$dismiss();
                            }, function () {
                                toastr.error('Unable to upload document.', 'Error');
                                $scope.uploading = false;
                            });
                        }
                    }

                    $scope.cancel = function () {
                        $scope.$dismiss();
                    };
                }],
                resolve: {
                    primaryCategories: function() {
                        return vm.primaryCategories;
                    },
                    secondaryCategories: function() {
                        return vm.secondaryCategories;
                    }
                }
            });
        }

        function editDocument(document) {
            restangular
                .one('documents', document.id)
                .get()
                .then(function (documentDetails) {
                    $uibModal.open({
                        templateUrl: 'admin/documents/edit.html',
                        controller: ['$scope', 'Upload', 'cfpLoadingBar', 'document', 'primaryCategories', 'secondaryCategories',
                            function ($scope, upload, cfpLoadingBar, document, primaryCategories, secondaryCategories) {

                            $scope.roles = _.filter(appData.applicationRoles, function (item) {
                                return item !== 'Administrator';
                            });
                            $scope.fileChanged = false;
                            $scope.selectedRoles = document.roles;

                            $scope.primaryCategories = primaryCategories;
                            $scope.secondaryCategories = secondaryCategories;

                            $scope.document = $scope.selectedFile = document;

                            $scope.roleChanged = function () {
                                $scope.document.roles = $scope.selectedRoles.join(',');
                            };
                            $scope.roleChanged();

                            $scope.fileSelect = function (file) {
                                $scope.fileChanged = true;
                                $scope.selectedFile = file;
                            }

                            $scope.roleSelected = function () {
                                return $scope.document.roles.length > 0;
                            }

                            $scope.onPrimaryCategoryChange = function () {
                                $scope.filteredCategories = _.filter(secondaryCategories, function (o) { return o.primaryCategory == $scope.document.primaryCategory; });
                            }

                            $scope.onPrimaryCategoryChange();

                            $scope.update = function (form) {
                                var data = {};
                                if (form.$valid) {
                                    if ($scope.fileChanged) {
                                        $scope.cfpLoadingBar = cfpLoadingBar;
                                        $scope.uploading = true;
                                        var data = _.extend({ file: $scope.selectedFile }, $scope.document);
                                    } else {
                                        var data = $scope.document;
                                    }
                                    upload.upload({
                                        url: appData.applicationRoot + 'api/documents/update',
                                        data: data,
                                        transformRequest: angular.identity,
                                        headers: { 'Content-Type': undefined }
                                    }).then(function () {
                                        toastr.info('Document updated successfully.', 'Notification');
                                        $scope.uploading = false;
                                        fetch();
                                        $scope.$dismiss();
                                    }, function () {
                                        toastr.error('Unable to update document.', 'Error');
                                        $scope.uploading = false;
                                    });
                                }
                            }

                            $scope.cancel = function () {
                                $scope.$dismiss();
                            };
                        }],
                        resolve: {
                            document: function() {
                                return documentDetails;
                            },
                            primaryCategories: function () {
                                return vm.primaryCategories;
                            },
                            secondaryCategories: function () {
                                return vm.secondaryCategories;
                            }
                        }
                    });
                });
            
        }
    };

    angular
        .module('app')
        .controller('AdminDocumentsCtrl', ['Restangular', 'toastr', '$scope', '$uibModal', 'appData', '$window', 'authService', AdminDocumentsCtrl]);

})();